import Vue from 'vue'
import store from '@/store';
// 权限检查方法
const authPermission = (value) => {
  let isExit = false;
  const {buttonPermission} = store.state.user;
  if (buttonPermission === undefined || buttonPermission=== null) {
      return false;
  }
  for (let i = 0; i < buttonPermission.length; i+=1) {
      const buttonpermsStrId = buttonPermission[i];
      if (buttonpermsStrId.uri === value) {
        isExit = true;
        break;
      }
  }
  return isExit;
};

const auth = () => {
  Vue.directive("auth", {
    inserted(el, binding) {
        // 获取按钮权限// 获取按钮权限
        if (!authPermission(binding.value)) {
            el.parentNode.removeChild(el);
        }
    }
  });
}

export default auth